import { FieldType, ViewModelBase } from "@shoothill/core";
import { action } from "mobx";
import { QualificationEditModel } from "../Models/QualificationEditModel";

export class QualificationEditViewModel extends ViewModelBase<QualificationEditModel> {
    beforeUpdate?(fieldName: any, value: any) {
        //throw new Error("Method not implemented.");
    }
    afterUpdate?(fieldName: any, value: any): void {
        //throw new Error("Method not implemented.");
    }
    constructor(dto?: any) {
        super(new QualificationEditModel());
        this.setDecorators(this.model);
        if (dto) {
            this.model.fromDto(dto);
        }
    }

    @action
    public setPassed = (value: boolean | null) => {
        this.model.passed = value;
    };

    @action
    public setExpiryDate = (value: string | null) => {
        this.model.expiryDate = value;
    };

    public async isFieldValid(fieldName: keyof FieldType<QualificationEditModel>): Promise<boolean> {
        const { isValid, errorMessage } = await this.validateDecorators(fieldName);
        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);
        return isValid;
    }
}
